<template>
  <div class="overflow-x-auto">
    <table class="wz-table w-full">
      <thead>
        <tr>
          <th>Parámetro</th>
          <th v-if="showRegime">Régimen</th>
          <th>Vigente desde</th>
          <th>Vigente hasta</th>
          <th style="text-align: right;">Valor</th>
          <th>Base legal</th>
          <th style="width: 150px;"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="definitions.length === 0">
          <td :colspan="showRegime ? 7 : 6" class="text-center text-muted py-4">No hay parámetros para mostrar.</td>
        </tr>
        <template v-for="d in definitions">
          <tr :key="d.code" class="lp-def-row">
            <td :colspan="showRegime ? 5 : 4">
              <strong>{{ d.label }}</strong>
              <i v-if="d.warning" class="ri-error-warning-line text-warning ml-1" :title="d.warning"></i>
              <div class="text-muted text-xs">
                <span v-if="d.usedIn">Usado en: {{ d.usedIn }}</span>
                <span v-if="d.description"> · {{ d.description }}</span>
              </div>
            </td>
            <td class="text-muted text-xs">{{ d.legalBasis }}</td>
            <td style="text-align: right;">
              <wz-button size="sm" variant="primary" @click="$emit('new', { definition: d })">
                <i class="ri-add-line mr-1"></i>Nueva vigencia
              </wz-button>
            </td>
          </tr>
          <tr v-if="!d.values || d.values.length === 0" :key="d.code + '-empty'">
            <td :colspan="showRegime ? 7 : 6" class="text-muted text-sm pl-6">Sin vigencias registradas.</td>
          </tr>
          <tr v-for="v in sortedValues(d)" :key="d.code + '-' + v.id" :class="{ 'lp-row-closed': v.closed }">
            <td class="pl-6 text-sm">
              <wz-badge v-if="isCurrent(v)" variant="info-solid" pill>Vigente</wz-badge>
              <wz-badge v-else-if="v.closed" variant="dark" pill>Cerrada</wz-badge>
              <wz-badge v-else variant="warning-solid" pill>Futura</wz-badge>
            </td>
            <td v-if="showRegime">{{ regimeLabel(v.laborRegime) }}</td>
            <td>{{ formatIsoDate(v.validFrom) }}</td>
            <td>{{ v.validTo ? formatIsoDate(v.validTo) : '(vigente)' }}</td>
            <td style="text-align: right;">{{ formatParameterValue(v.value, d.unit) }}</td>
            <td class="text-sm">{{ v.legalBasis || '—' }}</td>
            <td style="text-align: right;">
              <wz-button v-if="v.editable && !v.closed" size="sm" variant="outline" @click="$emit('edit', { definition: d, row: v })">
                Editar
              </wz-button>
              <wz-tooltip v-else :text="v.closed ? 'Vigencia cerrada: no se edita' : 'Tiene cálculos asociados: no se edita, cree una nueva vigencia'">
                <i class="ri-lock-line text-muted"></i>
              </wz-tooltip>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import { formatParameterValue, formatIsoDate, REGIME_LABELS } from '../utils/format'

export default {
  name: 'LegalParameterSeriesTable',
  props: {
    definitions: { type: Array, default: () => [] },
    today: { type: String, required: true },
    showRegime: { type: Boolean, default: false },
    companyId: { type: [Number, String], default: null },
  },
  methods: {
    formatParameterValue,
    formatIsoDate,
    regimeLabel(r) { return r ? (REGIME_LABELS[r] || r) : '—' },
    isCurrent(v) { return v.validFrom <= this.today && (!v.validTo || v.validTo >= this.today) },
    // Por régimen y, dentro de cada serie, la vigencia más reciente primero.
    sortedValues(d) {
      return (d.values || []).slice().sort((a, b) => {
        const ra = a.laborRegime || '', rb = b.laborRegime || ''
        if (ra !== rb) return ra < rb ? -1 : 1
        return a.validFrom < b.validFrom ? 1 : -1
      })
    },
  },
}
</script>

<style lang="stylus">
.lp-def-row td
  background #f8fafc
.lp-row-closed td
  color #9ca3af
</style>
